<template>
<div class="page auth-page login-page">
	<background-image
		type="interval"
		:interval="20000"
	/>
	<div class="modal-window content">
		<div class="modal-content">
			<grid>
				<img src="@/assets/images/logo.svg" alt="logo" class="logo">
			</grid>
			<grid>
				<grid-item size="1/1">
					<custom-input
						type="text"
						placeholder="Email Address"
						iconClass="icon-user"
						inputStyle="light"
					/>
					<custom-input
						type="password"
						placeholder="Password"
						iconClass="icon-lock-filled"
						inputStyle="light"
					/>
				</grid-item>
			</grid>
			<grid>
				<grid-item size="1/1">
					<router-link to="/" class="button primary login-button">Login</router-link>
				</grid-item>
			</grid>
			<grid>
				<grid-item size="1/1">
					<span>
						Forgot password?
						<a>Click here</a>
					</span>
				</grid-item>
			</grid>
			<hr>
			<social-login />
		</div>
		<div class="modal-content modal-content-after">
			<h5>Don't have an account?</h5>
			<router-link to="/register">
				REGISTER
			</router-link>
		</div>
	</div>
</div>
</template>

<script>
import CustomInput from '@/components/secondary/CustomInput'
import SocialLogin from './components/SocialLogin'
import BackgroundImage from '@/components/main/BackgroundImage'

export default {
	components: {
		CustomInput,
		SocialLogin,
		BackgroundImage
	}
}
</script>

<style lang="scss">
.login-page {
	.login-button {
		margin: 8px 0px;
	}

	span {
		color: #fff;
		font-size: 13px;
	}
	
	a {
		border-bottom: 1px solid currentColor;
		font-weight: 600;
		cursor: pointer;
	}
}
</style>
